'use strict';

angular.module('membership')
  .controller('VendorsCtrl', [
    '$scope', 'vendorsViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel($scope.company);
    }
  ]);
